export default __webpack_public_path__ + "static/media/ic_check_white.a35643d4.svg";